import { atom } from '@zedux/react'

const mailTemplateIdAtom = atom("mailTemplateIdAtom", 0)

export default mailTemplateIdAtom